// // Indentvaliditycomponent.js
import React from 'react';
import CountdownTimer from './runningtime.js';
var moment = require('moment');

// var moment = require('moment');
// const Indentvaliditycomponent = (props) => {
//   const indent = props.data;

//   if (indent.is_draft === 1) {
//     return null;
//   }
//   const expirationTime = moment(indent.bid_start_date)
//   .add(parseInt(indent.quotation_validity_hours), 'hours')
//   .toDate();
//   console.log(indent.bid_start_date,indent.quotation_validity_hours,indent.indent_id)
//   console.log(expirationTime,'15')

//   return (
//     <span style={{ fontSize: '13px', fontWeight: 500 }}>
//        <CountdownTimer expirationTime={expirationTime} indent={indent} />

//   </span>
//   );
// };

//  export default Indentvaliditycomponent;
const Indentvaliditycomponent = (props) => {
    const indent = props.data;
  
    if (indent.is_draft === 1) return null;
  
    const startDate = moment(indent.bid_start_date, "DD-MM-YYYY HH:mm");
    let expirationTime = null;
  
    if (startDate.isValid() && indent.quotation_validity_hours) {
      expirationTime = startDate
        .add(parseInt(indent.quotation_validity_hours), 'hours')
        .toDate();
    }
  
    console.log(indent.bid_start_date, indent.quotation_validity_hours, indent.indent_id);
  
    return (
      <span style={{ fontSize: '13px', fontWeight: 500 }}>
        {expirationTime ? (
          <CountdownTimer expirationTime={expirationTime} indent={indent} />
        ) : (
          <span style={{ color: 'red' }}>Invalid Expiration Time</span>
        )}
      </span>
    );
  };
  export default Indentvaliditycomponent;

  
